import { render, staticRenderFns } from "./imcNinas0a2A.vue?vue&type=template&id=ff44f27c&scoped=true&"
import script from "./imcNinas0a2A.vue?vue&type=script&lang=js&"
export * from "./imcNinas0a2A.vue?vue&type=script&lang=js&"
import style0 from "./imcNinas0a2A.vue?vue&type=style&index=0&id=ff44f27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff44f27c",
  null
  
)

export default component.exports